(() => {
  'use strict';
  if (window.__ingoElectionToolsInstalled) return;
  window.__ingoElectionToolsInstalled = true;
  const START = Date.parse('2026-10-26T00:00:00+02:00');
  const END = Date.parse('2026-10-28T00:00:00+02:00');
  const TARGET_ID = 187191001301;
  const theme = window.Shopify && window.Shopify.theme;
  const isCampaign = theme && Number(theme.id) === TARGET_ID;
  const previewID = isCampaign && theme.role === 'unpublished' ? String(theme.id) : null;
  const PREVIEW_STATE_KEY = 'ingo_election_clock_preview_187191001301';
  const previewFlag = new URLSearchParams(location.search).get('ingo_timer_preview');
  let demo = false;
  let demoStarted = Date.now();
  // Owner-only UI preference, no identity, coupon or analytics data. Never enables production demo.
  if (previewID && Date.now() < END) {
    let state = null;
    try { state = JSON.parse(localStorage.getItem(PREVIEW_STATE_KEY) || 'null'); } catch (_) {}
    const valid = state && state.endAt === END && Number.isFinite(state.startedAt) && state.startedAt <= Date.now() && Date.now() - state.startedAt < 48 * 3600 * 1000;
    if (previewFlag === '0') {
      try { localStorage.removeItem(PREVIEW_STATE_KEY); } catch (_) {}
    } else if (previewFlag === '1' || valid) {
      demo = true;
      demoStarted = valid ? state.startedAt : Date.now();
      try { localStorage.setItem(PREVIEW_STATE_KEY, JSON.stringify({ startedAt: demoStarted, endAt: END })); } catch (_) {}
    }
  } else {
    try { localStorage.removeItem(PREVIEW_STATE_KEY); } catch (_) {}
  }
  const pad = value => String(value).padStart(2, '0');
  function remainingParts(end, now) {
    const remaining = Math.max(0, Math.ceil((end - now) / 1000));
    return [pad(Math.floor(remaining / 3600)), pad(Math.floor((remaining % 3600) / 60)), pad(remaining % 60)];
  }
  function previewDestination(url) {
    const path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/, '') || '/';
    return url.origin === location.origin && /^\/(?:$|collections(?:\/|$)|products(?:\/|$)|pages(?:\/|$)|blogs(?:\/|$)|cart(?:\/|$)|search(?:\/|$))/.test(path);
  }
  function preservePreviewNavigation(link) {
    if (!previewID || !demo || !link || link.hasAttribute('download')) return;
    const raw = link.getAttribute('href');
    if (!raw || raw[0] === '#') return;
    let url;
    try { url = new URL(raw, location.origin); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    if (previewDestination(url)) {
      url.searchParams.set('preview_theme_id', previewID);
      url.searchParams.set('ingo_timer_preview', '1');
    } else if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?discount\//.test(url.pathname) && url.searchParams.has('redirect')) {
      // Preserve the existing coupon and destination; only carry owner preview parameters.
      let destination;
      try { destination = new URL(url.searchParams.get('redirect'), location.origin); } catch (_) { return; }
      if (!previewDestination(destination)) return;
      destination.searchParams.set('preview_theme_id', previewID);
      destination.searchParams.set('ingo_timer_preview', '1');
      url.searchParams.set('redirect', destination.pathname + destination.search + destination.hash);
    } else return; // Never rewrite checkout, login, account, external or non-navigation links.
    const href = url.pathname + url.search + url.hash;
    if (link.getAttribute('href') !== href) link.setAttribute('href', href);
  }
  function patchLinks() {
    document.querySelectorAll('[data-election-size-source]').forEach(nav => {
      const collectionPage = nav.dataset.electionSizeSource === 'collection';
      const current = new URLSearchParams(location.search).get('gf_640439');
      nav.querySelectorAll('[data-election-size], [data-election-all-sizes]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.origin);
        if (collectionPage) {
          url.search = location.search;
          url.searchParams.delete('page');
          url.searchParams.delete('cursor');
          if (link.dataset.electionSize) url.searchParams.set('gf_640439', link.dataset.electionSize);
          else url.searchParams.delete('gf_640439');
        }
        if (previewID) url.searchParams.set('preview_theme_id', previewID);
        if (demo && previewID) url.searchParams.set('ingo_timer_preview', '1');
        const href = url.pathname + url.search;
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        const selected = !!collectionPage && !!link.dataset.electionSize && current === link.dataset.electionSize;
        if (selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    });
    document.querySelectorAll('[data-election-float-link]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      if (previewID) url.searchParams.set('preview_theme_id', previewID);
      if (demo && previewID) url.searchParams.set('ingo_timer_preview', '1');
      const href = url.pathname + url.search;
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
    if (previewID && demo) document.querySelectorAll('a[href]').forEach(preservePreviewNavigation);
  }
  function dockClocks() {
    const vv = window.visualViewport;
    const leftEdge = vv ? vv.offsetLeft : 0;
    const topEdge = vv ? vv.offsetTop : 0;
    const viewWidth = vv ? vv.width : document.documentElement.clientWidth;
    const viewHeight = vv ? vv.height : document.documentElement.clientHeight;
    document.querySelectorAll('[data-ingo-election-floating]').forEach(floating => {
      if (floating.hidden) return;
      const css = getComputedStyle(floating);
      const oldX = parseFloat(floating.style.getPropertyValue('--ingo-clock-x-adjust')) || 0;
      const oldBottom = parseFloat(floating.style.getPropertyValue('--ingo-clock-bottom-adjust')) || 0;
      const baseLeft = (parseFloat(css.left) || 0) - oldX;
      const baseBottom = (parseFloat(css.bottom) || 0) - oldBottom;
      const box = floating.getBoundingClientRect();
      const x = Math.max(leftEdge + 6, Math.min(leftEdge + baseLeft, leftEdge + viewWidth - box.width - 6));
      let y = topEdge + viewHeight - baseBottom - box.height;
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart(?:\/|$)/.test(location.pathname)) {
        document.querySelectorAll('button[name="checkout"],input[name="checkout"],a[href*="/checkout"]').forEach(button => {
          const r = button.getBoundingClientRect();
          if (!r.width || !r.height || r.bottom < topEdge || r.top > topEdge + viewHeight) return;
          if (x < r.right && x + box.width > r.left && y < r.bottom && y + box.height > r.top) y = r.top - box.height - 12;
        });
      }
      y = Math.max(topEdge + 8, y);
      const nextX = oldX + x - box.left;
      const nextBottom = oldBottom + box.top - y;
      if (Math.abs(nextX - oldX) > 0.5) floating.style.setProperty('--ingo-clock-x-adjust', nextX + 'px');
      if (Math.abs(nextBottom - oldBottom) > 0.5) floating.style.setProperty('--ingo-clock-bottom-adjust', nextBottom + 'px');
    });
  }
  let dockQueued = false;
  function queueDock() {
    if (dockQueued) return;
    dockQueued = true;
    requestAnimationFrame(() => { dockQueued = false; dockClocks(); });
  }
  function tick() {
    const now = Date.now();
    document.querySelectorAll('[data-ingo-election-countdown]').forEach(counter => {
      const before = now < START;
      counter.hidden = before;
      counter.dataset.state = before ? 'before' : now >= END ? 'ended' : 'active';
      if (before) return;
      const title = counter.querySelector('[data-countdown-title]');
      const digits = counter.querySelector('[data-countdown-digits]');
      if (now >= END) { title.textContent = 'המבצע הסתיים'; digits.hidden = true; return; }
      title.textContent = 'המבצע מסתיים בעוד'; digits.hidden = false;
      const parts = remainingParts(END, now);
      ['hours','minutes','seconds'].forEach((unit, i) => { counter.querySelector('[data-countdown-' + unit + ']').textContent = parts[i]; });
    });
    document.querySelectorAll('[data-ingo-election-floating]').forEach(floating => {
      const show = isCampaign && (demo || (now >= START && now < END));
      floating.hidden = !show;
      floating.dataset.state = demo ? 'demo' : now < START ? 'before' : now >= END ? 'ended' : 'active';
      const end = demo ? demoStarted + 48 * 3600 * 1000 : END;
      floating.querySelector('[data-election-float-time]').textContent = remainingParts(end, now).join(':');
      floating.querySelector('[data-election-float-demo]').hidden = !demo;
    });
    queueDock();
  }
  function consentForAnalytics() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  function trackSize(link) {
    // Only real campaign production clicks, within48h and with merchant analytics consent.
    // No preview/test traffic, personal data, coupon token or full query string is sent.
    const now = Date.now();
    const previewQuery = new URLSearchParams(location.search);
    if (previewQuery.has('preview_theme_id') || previewQuery.has('ingo_timer_preview')) return;
    if (!isCampaign || theme.role !== 'main' || previewID || now < START || now >= END || !consentForAnalytics() || typeof window.gtag !== 'function') return;
    const nav = link.closest('[data-election-size-source]');
    const source = nav && nav.dataset.electionSizeSource;
    const size = link.dataset.electionSize || 'all';
    if (!['home','collection'].includes(source) || !['1','2','3','4','5','6','OZ','all'].includes(size)) return;
    window.gtag('event', 'ingo_election_size_' + source + '_' + size.toLowerCase(), {
      send_to: 'G-7H6TT5BQEB', size: size, placement: source,
      action: size === 'all' ? 'reset' : 'filter', campaign: 'election_2026',
      page_location: location.origin + location.pathname, page_referrer: '', transport_type: 'beacon'
    });
  }
  document.addEventListener('click', event => {
    const navigation = event.target.closest && event.target.closest('a[href]');
    if (navigation) preservePreviewNavigation(navigation);
    const link = event.target.closest && event.target.closest('a[data-election-size], a[data-election-all-sizes]');
    if (link) trackSize(link);
  });
  patchLinks();tick();
  window.setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', () => { patchLinks(); tick(); });
  document.addEventListener('visibilitychange', tick);
  window.addEventListener('scroll', queueDock, { passive: true });
  window.addEventListener('resize', queueDock);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queueDock);
    window.visualViewport.addEventListener('scroll', queueDock);
  }
  window.addEventListener('pageshow', () => { patchLinks(); tick(); });
})();
